<!-- 轮播图下方三个按钮：图片做底，文字定位覆盖在图上 -->
<script lang="ts">
  import { _ as t } from "svelte-i18n";
  import leftBtn from "../assets/images/ui/btn-venue.png";
  import registerBtn from "../assets/images/ui/btn-register.png";
  import disabledRegisterBtn from "../assets/images/ui/bg-notstarted.png";
  import rightBtn from "../assets/images/ui/btn-code.png";

  type RegisterState =
    | "active"
    | "notStarted"
    | "ended"
    | "ineligible"
    | "registered";

  interface Props {
    onMainVenue?: () => void;
    onRegister?: () => void;
    onLotteryCode?: () => void;
    registerState?: RegisterState;
    /**
     * 紧凑模式：用于 76px 高的吸底栏，只改整行的上偏移，不动三个按钮之间的相对关系。
     * banner 里用 -35px 把整行压在轮播图上；吸底栏用 -15px，
     * 让药丸底边距吸底栏底部 15px（设计稿）。
     *
     * 登记键高 82px 且 translate-y-19px，行内按底边对齐，视觉底边 = 偏移 + 19 + 82 = 86，
     * 比吸底栏 76px 的内容盒多出 10px：多出来的是图片下缘的发光，按设计稿允许溢出，
     * 有安全区的机型落在 padding 里，没有安全区时（桌面 / 部分 Android）会被裁掉，药丸本身不受影响。
     */
    compact?: boolean;
  }

  let {
    onMainVenue,
    onRegister,
    onLotteryCode,
    registerState = "active",
    compact = false,
  }: Props = $props();

  /** 未开始 / 已结束 / 不符合条件：置灰且不可点，点击不做任何响应 */
  let registerDisabled = $derived(
    registerState === "notStarted" ||
      registerState === "ended" ||
      registerState === "ineligible",
  );
  let registerTextKey = $derived(
    {
      active: "register_now",
      notStarted: "register_not_started",
      ended: "register_ended",
      ineligible: "register_ineligible",
      registered: "register_registered",
    }[registerState],
  );
</script>

<!--
  三个按钮按"盒子底边对齐"排（items-end），登记键再单独下移 19px。
  这 19px 不是装饰：量过切图，两侧按钮的实心药丸底边距盒子底 1.5px，
  登记键的药丸底边距盒子底 20.5px，差值就是 19px，补上之后三个药丸底边才在同一条线。
-->
<div
  class="relative w-full flex items-end justify-between {compact
    ? 'mt-[-18px]'
    : 'mt-[-25px]'}"
>
  <!-- 两侧按钮各往外挪 2px：用 translate 而不是 margin，避免改变行内 justify-between 的分配 -->
  <button
    type="button"
    class="relative block w-[80px] h-[64px] shrink-0 -translate-x-[2px]"
    onclick={onMainVenue}
  >
    <img src={leftBtn} alt="" class="w-full h-full block" />
    <span class="label-side absolute left-0 right-0 bottom-[3px] text-center">
      {$t("main_venue")}
    </span>
  </button>

  <button
    type="button"
    class="relative block w-[214px] h-[82px] shrink-0 translate-y-[19px]"
    onclick={onRegister}
    disabled={registerDisabled}
  >
    <img
      src={registerDisabled ? disabledRegisterBtn : registerBtn}
      alt=""
      class="w-full h-full block"
    />
    <span
      class="label-main absolute left-0 right-0 top-[8px] h-[54px] flex items-center justify-center text-center"
      class:is-registered={registerState === "registered"}
    >
      {$t(registerTextKey)}
    </span>
  </button>

  <button
    type="button"
    class="relative block w-[80px] h-[67px] shrink-0 translate-x-[2px]"
    onclick={onLotteryCode}
  >
    <img src={rightBtn} alt="" class="w-full h-full block" />
    <span class="label-side absolute left-0 right-0 bottom-[3px] text-center">
      {$t("lottery_code")}
    </span>
  </button>
</div>

<style>
  .label-side {
    font-size: 16px;
    font-weight: 800;
    line-height: 180%;
    letter-spacing: 0;
    color: #ffffff;
    text-shadow: 0 2px 2px #003ec7;
  }

  .label-main {
    font-size: 20px;
    font-weight: 800;
    line-height: 180%;
    letter-spacing: 0;
    color: #ffffff;
    text-shadow: 0 2px 1px rgba(3, 0, 45, 0.5);
  }

  /* 已登记文案较长，按设计稿使用 16px / ExtraBold。 */
  .label-main.is-registered {
    font-size: 16px;
  }
</style>
